module.exports = __webpack_public_path__ + "img/receipt.473a3c99.svg";